var map = {
	"./all_lang.json": 780,
	"./bn.json": 781,
	"./cn.json": 782,
	"./cz.json": 783,
	"./de.json": 784,
	"./en.json": 785,
	"./es.json": 786,
	"./fr.json": 787,
	"./hi.json": 788,
	"./id.json": 2191,
	"./it.json": 789,
	"./jp.json": 790,
	"./ko.json": 791,
	"./nl.json": 792,
	"./pl.json": 793,
	"./pt.json": 794,
	"./ru.json": 795,
	"./sk.json": 796,
	"./tu.json": 797,
	"./ua.json": 798,
	"./ur.json": 799,
	"./vt.json": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2190;